"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _basic_provider = _interopRequireDefault(require("./_basic_provider"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var IdentifiersApi =
/*#__PURE__*/
function (_BasicProviderApi) {
  (0, _inherits2.default)(IdentifiersApi, _BasicProviderApi);

  /**
   * @constructor
   */
  function IdentifiersApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        sdkApiUrl = _ref.sdkApiUrl,
        providersAccountId = _ref.providersAccountId,
        accountId = _ref.accountId;
    (0, _classCallCheck2.default)(this, IdentifiersApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IdentifiersApi).call(this, {
      userTokenFactory: userTokenFactory,
      sdkApiUrl: sdkApiUrl,
      providersAccountId: providersAccountId
    }));
    _this.accountId = accountId;
    _this.axios = _this._createAxios();
    return _this;
  }
  /**
   * Get identifiers
   * @param {string=} identifier
   *
   * @async
   */


  (0, _createClass2.default)(IdentifiersApi, [{
    key: "listIdentifiers",
    value: function () {
      var _listIdentifiers = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var identifier,
            queryParams,
            _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                identifier = _args.length > 0 && _args[0] !== undefined ? _args[0] : undefined;
                queryParams = {
                  accountId: this.accountId,
                  fullInfo: "true",
                  groupDetails: "true",
                  identifier: identifier
                };
                _context.next = 4;
                return this._callApi({
                  method: 'get',
                  path: "/identifiers",
                  queryParams: queryParams
                });

              case 4:
                return _context.abrupt("return", _context.sent);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function listIdentifiers() {
        return _listIdentifiers.apply(this, arguments);
      }

      return listIdentifiers;
    }()
    /**
     * Get list of obtainable identifiers
     * @param {Object=} params
     * @param {string} params.country - Two letter country identifier to list number from
     * @param {string} params.region - Two letter state identifier (applicable to US/CA) to list numbers from
     * @param {('local'|'tollfree'|'mobile')} params.type - Phone number type ("local", "tollfree", "mobile")
     * @param {number} params.limit - Limit number of phone numbers in a list
     * @param {string} params.pattern - Set of digits a number should contain, start with or ends with
     * @param {('starts'|'ends'|'contains')} params.patternType - Where the `pattern` should be located relative to the phone number ("starts", "ends", "contains")
     * @param {Array.<'voice'|'sms'|'mms'>} params.capabilities - Array of preferred capabilities ("voice", "sms", "mms")
     * @returns {Object[]}
     * @async
     */

  }, {
    key: "getObtainableIdentifiers",
    value: function () {
      var _getObtainableIdentifiers = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2() {
        var params,
            queryParams,
            _args2 = arguments;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                queryParams = _objectSpread({
                  accountId: this.accountId
                }, params);
                _context2.next = 4;
                return this._callApi({
                  method: 'get',
                  path: "/obtainable-identifiers",
                  queryParams: queryParams
                });

              case 4:
                return _context2.abrupt("return", _context2.sent);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getObtainableIdentifiers() {
        return _getObtainableIdentifiers.apply(this, arguments);
      }

      return getObtainableIdentifiers;
    }()
    /**
     * Remove identifiers
     * @param {string} identifier
     * @async
     */

  }, {
    key: "releaseIdentifier",
    value: function () {
      var _releaseIdentifier = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(identifier) {
        var queryParams;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                queryParams = {
                  accountId: this.accountId,
                  identifier: identifier
                };
                _context3.next = 3;
                return this._callApi({
                  method: 'delete',
                  path: "/identifiers",
                  queryParams: queryParams
                });

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function releaseIdentifier(_x) {
        return _releaseIdentifier.apply(this, arguments);
      }

      return releaseIdentifier;
    }()
    /**
     * Buy identifiers
     * @param {Array.<{provider: string, phoneNumber: string}>} identifiers
     * @async
     */

  }, {
    key: "buyIdentifier",
    value: function () {
      var _buyIdentifier = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(identifiers) {
        var payload;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                payload = {
                  accountId: this.accountId,
                  identifiers: Array.isArray(identifiers) ? identifiers : [identifiers]
                };
                _context4.next = 3;
                return this._callApi({
                  method: 'post',
                  path: "/identifiers",
                  payload: payload
                });

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function buyIdentifier(_x2) {
        return _buyIdentifier.apply(this, arguments);
      }

      return buyIdentifier;
    }()
    /**
     * Create new provider
     *
     * @param {String} provider - provider name
     * @param {Object} settings - settings object
     * @async
     */

  }, {
    key: "createProvider",
    value: function () {
      var _createProvider = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(provider) {
        var settings,
            payload,
            _args5 = arguments;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                settings = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
                payload = {
                  accountId: this.accountId,
                  provider: provider,
                  settings: settings
                };
                _context5.next = 4;
                return this._callApi({
                  method: 'post',
                  path: "/identifier-providers",
                  payload: payload
                });

              case 4:
                return _context5.abrupt("return", _context5.sent);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function createProvider(_x3) {
        return _createProvider.apply(this, arguments);
      }

      return createProvider;
    }()
    /**
     * List providers
     * @returns {Object[]}
     * @async
     */

  }, {
    key: "listProviders",
    value: function () {
      var _listProviders = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6() {
        var queryParams;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                queryParams = {
                  accountId: this.accountId
                };
                _context6.next = 3;
                return this._callApi({
                  method: 'get',
                  path: "/identifier-providers",
                  queryParams: queryParams
                });

              case 3:
                return _context6.abrupt("return", _context6.sent);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function listProviders() {
        return _listProviders.apply(this, arguments);
      }

      return listProviders;
    }()
    /**
     * Remove providers
     *
     * @async
     */

  }, {
    key: "removeProviders",
    value: function () {
      var _removeProviders = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(provider) {
        var payload;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                payload = {
                  accountId: this.accountId,
                  provider: provider
                };
                _context7.next = 3;
                return this._callApi({
                  method: 'delete',
                  path: "/identifier-providers",
                  payload: payload
                });

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function removeProviders(_x4) {
        return _removeProviders.apply(this, arguments);
      }

      return removeProviders;
    }()
  }]);
  return IdentifiersApi;
}(_basic_provider.default);

var _default = IdentifiersApi;
exports.default = _default;